<template>
    <div class="card">
        <div class="card-title">
            Результаты
        </div>
        <template v-if="hasResults">
            <div class="card-info-row">
                <div class="card-info-block">
                    <div class="card-label">
                        Набранные баллы
                    </div>
                    <div class="card-value-blue">
                        {{ score }}
                    </div>
                </div>
                <div class="card-info-block">
                    <div class="card-label">
                        Время прохождения
                    </div>
                    <div class="card-value-red">
                        {{ time }}
                    </div>
                </div>
                <div class="card-info-block">
                    <div class="card-label">
                        Выполненные задания
                    </div>
                    <div class="card-value-blue">
                        {{ answers }}
                    </div>
                </div>
            </div>
            <div class="card-content">
                <MainTestResult :content="test.results"/>
            </div>
        </template>
        <template v-else>
            <div class="card-empty">Результаты не найдены</div>
        </template>
        <div class="card-actions-row">
            <button
                type="button"
                class="white-button card-button"
                @click="$emit('confirm')"
            >
                {{ hasResults ? 'Все понятно' : 'Закрыть'}}
            </button>
        </div>
    </div>
</template>

<script>
import MainTestResult from './components/MainTestResult';

export default {
    name: "TestResultsCard",

    components: {
        MainTestResult,
    },

    props: {
        test: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        hasResults() {
            return true;
        },

        score() {
            return this.test.score || 0;
        },

        time() {
            const start = this.moment(this.test.testingDatetimeBegin);
            const end = this.moment(this.test.testingDatetimeEnd);

            if (start.isValid() && end.isValid()) {
                return this.moment.utc(end.diff(start)).format('HH:mm:ss');
            }

            return '00:00:00';
        },

        answers() {
            return `${ this.test.numberAnswers } из ${ this.test.numberQuestions }`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.card {
    width: rem(760);
    padding: rem(40);
    border-radius: rem(4);
    background-color: #FFFFFF;

    @include on-mobile {
        width: 100%;
        padding: 0;
        border-radius: mrem(4);
    }

    &-title {
        margin-bottom: rem(32);
        font-weight: 600;
        font-size: rem(24);
        line-height: rem(29);
        text-align: center;
        color: #2A2626;

        @include on-mobile {
            margin-bottom: mrem(24);
            font-size: mrem(24);
            line-height: mrem(29);
        }
    }

    &-info-row {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0 0 rem(24) 0;
        margin: 0 0 rem(24) 0;
        border-bottom: 1px solid #D2D5D9;

        @include on-mobile {
            padding: 0 0 mrem(16) 0;
            margin: 0 0 mrem(16) 0;
        }
    }

    &-info-block {
        margin: 0 rem(55) 0 0;

        @include on-mobile {
            margin: 0 mrem(48) 0 0;
        }

        &:last-of-type {
            margin: 0;
        }
    }

    &-label {
        margin-bottom: rem(4);
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        font-size: rem(12);
        line-height: rem(16);
        color: #2A2626;

        @include on-mobile {
            margin-bottom: mrem(4);
            font-size: mrem(12);
            line-height: mrem(14);
        }
    }

    &-value-blue, &-value-red {
        font-family: 'Open Sans', sans-serif;
        font-weight: 600;
        font-size: rem(24);
        line-height: rem(33);

        @include on-mobile {
            font-size: mrem(18);
            line-height: mrem(24);
        }
    }

    &-value-blue {
        color: #4663AB;
    }

    &-value-red {
        color: #D1004A;
    }

    &-actions-row {
        width: 100%;
        margin: rem(32) 0 0 0;
        text-align: center;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: flex-start;

        @include on-mobile {
            margin: mrem(32) 0 0 0;
        }
    }

    &-empty {
        margin-bottom: rem(32);
        font-family: 'Open Sans', sans-serif;
        font-size: rem(16);
        line-height: rem(26);
        color: #2A2626;

        @include on-mobile {
            margin-bottom: mrem(32);
            font-size: mrem(16);
            line-height: mrem(26);
        }
    }
}
</style>

<style lang="scss">
@import '~@/styles/rem';

.card-content {
    .main {
        padding: 0;
    }
    h1, h2, h3 {
        margin: 0 0 rem(16) 0;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(28);
        color: #2A2626;

        @include on-mobile {
            margin: 0 0 mrem(16) 0;
            font-size: mrem(18);
            line-height: mrem(28);
        }
    }

    p {
        font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: rem(16);
        line-height: rem(26);
        color: #2A2626;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(26);
        }
    }
}
</style>